import React, { Component } from 'react';
import menuesRootview from './../menues_rootview.js';
import Header from './header.js';

class MenuGlobal extends Component {
	componentWillMount() {
		menuesRootview.openGlobalMenu();
	}

	componentWillUnmount() {
		menuesRootview.close();
	}

	render() {
		return (
			<div id="menu-global">
				<Header />
			</div>
		);
	}
}

export default MenuGlobal;



// WEBPACK FOOTER //
// ./mobile-core/src/components/menu-global.js